import { call, put } from "redux-saga/effects";

import {
    receivedQuizesAnswers,
    quizesAnswersError,
} from "../actions/quizesAnswers";
import { showErrorMessage } from "../actions/notification";
import * as quizApi from '../api/quiz';

const getQuizesErrorMsg = "Uh-oh! Something went wrong—try again.";

export function* getQuizesAnswers({ payload }) {
  try {
    let { data } = yield call(quizApi.getAllLastQuizUserAttemptsByProgram, payload);

    yield put(receivedQuizesAnswers(data));
  } catch (e) {
    yield put(quizesAnswersError());
    yield put(showErrorMessage({ text: getQuizesErrorMsg }));
    console.error(e);
  }
}
